module.exports = __webpack_public_path__ + "img/16_sp.05168feb.gif";